import React from 'react';
import LinkTableCell from '@components/Kendo/LinkTableCell';
function withInspectionId(path, inspectionId) {
    if (!path || !inspectionId)
        return path;
    const url = new URL(path, window.location.origin);
    url.searchParams.set('inspection_id', String(inspectionId));
    return `${url.pathname}${url.search}`;
}
function DeficiencyIdCell({ colSpan, dataItem, field = '', className = '', ariaColumnIndex, style = null, inspectionId, onDeficiencyClick }) {
    if (!onDeficiencyClick) {
        return (React.createElement(LinkTableCell, { colSpan: colSpan, dataItem: dataItem, field: field, className: className, ariaColumnIndex: ariaColumnIndex, style: style }));
    }
    return (React.createElement("td", { colSpan: colSpan, className: className, role: "gridcell", "aria-colindex": ariaColumnIndex, style: style || undefined },
        React.createElement("a", { href: withInspectionId(dataItem.idPath, inspectionId), "data-testid": `deficiency-id-link-${dataItem.id}`, onClick: (event) => {
                event.preventDefault();
                onDeficiencyClick(dataItem.id);
            } }, dataItem.id)));
}
export default DeficiencyIdCell;
